import { ActiveField, ActiveModel } from '@alt-point/active-models/src'

export class AcceptedFilter extends ActiveModel {
  @ActiveField('')
  key: string = ''

  @ActiveField()
  value?: any

  @ActiveField('')
  label: string = ''

  @ActiveField()
  remove: () => void = () => {}
}
